<template>
  <div class="cascader" v-loading="cascaderLoading">
    <el-scrollbar>
      <ul>
        <li
          class="cascader-menu"
          :ref="'cascader-menu_' + item.value"
          v-for="item in options"
          :key="item.value"
          @click="getBrandTypeData(item)"
        >
          <div>
            <el-checkbox
              :indeterminate="item.isIndeterminate"
              v-model="item.checked"
              style="margin-right: 12px"
              @change="handleCheckAllChange"
              :disabled="disabled || item.disabled"
            ></el-checkbox>
            <el-tooltip effect="dark" :content="item.text" placement="bottom" v-if="item.text.length > 6">
              <span class="text">{{ item.text }}</span>
            </el-tooltip>
            <span v-else>{{ item.text }}</span>
          </div>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
    </el-scrollbar>
    <el-scrollbar>
      <ul v-if="brandTypeDataActive.length">
        <el-checkbox-group
          v-model="brandDataActive.checkedChildren"
          @change="handleCheckedChange"
          ref="checkbox"
        >
          <li v-for="item in brandTypeDataActive" :key="item.value">
            <el-checkbox :disabled="disabled || (brandDataActive.disabledChildren && brandDataActive.disabledChildren.findIndex(i => i == item.value) > -1)" :label="item.value" @change="brandTypeChange($event, item)" style="margin-right: 12px">{{ item.text }}</el-checkbox>
          </li>
        </el-checkbox-group>
      </ul>
      <div v-else class="is-empty">
        <span>暂无数据</span>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  props: {
    args: Object,
    from: Object,
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    defaultDisabledKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cascaderLoading: false,
      options: [],
      brandArgs: {
        ...this.args,
        ...{
          url: "/Account/dataSearchVue/selectFirstType.html",
        }
      },
      brandTypeArgs: {
        ...this.args,
        ...{
          url: "/Account/dataSearchVue/selectSecondType.html",
          firstId: "",
          type: "",
        }
      },
      brandDataActive: {},
      brandTypeDataActive: []
    };
  },
  created() {
    this.getBrandData();
  },
  computed: {
    disabled () {
      return !Boolean(this.from?.warehouse?.value)
    }
  },
  watch: {
    defaultCheckedKeys (val) {
      if (val && val.length) {
        this.defaultCheckedOrDisabled(true)
      }
    },
    defaultDisabledKeys (val) {
      if (val && val.length) {
        this.defaultCheckedOrDisabled(false)
      }
    }
  },
  methods: {
    async getBrandData() {
      this.cascaderLoading = true;
      const { data: res } = await this.$http.post(
        this.brandArgs.url,
        this.Qs.stringify(this.brandArgs)
      );
      this.cascaderLoading = false;
      if (res.code != "success") return this.$message.error(res.message);
      let tempArr = JSON.parse(JSON.parse(res.result).data).map((i) => {
        i["isIndeterminate"] = false;
        i["checked"] = false;
        i["disabled"] = false;
        i["active"] = false;
        i["checkedChildren"] = [];
        i["disabledChildren"] = [];
        i["children"] = [];
        return i;
      });
      this.options = tempArr;
      this.getBrandTypeData(this.options[0], true);
    },
    async getBrandTypeData(row, isOnce) {
      if (!isOnce && this.disabled) {
        this.$message({
          showClose: true,
          message: '请先选择仓库',
          type: 'warning'
        })
      }
      let { loaded } = row
      $(".cascader-menu").removeClass("active");
      $(".cascader-menu").removeClass("active");
      this.$nextTick(() => {
        $(this.$refs["cascader-menu_" + row.value]).addClass("active");
      });
      this.brandDataActive = row;
      this.brandTypeArgs.firstId = row.value;
      this.brandTypeArgs.type = row.type;
      if (!loaded) {
        this.cascaderLoading = true;
        const { data: res } = await this.$http.post(
          this.brandTypeArgs.url,
          this.Qs.stringify(this.brandTypeArgs)
        );
        this.cascaderLoading = false;
        let tempArr = JSON.parse(JSON.parse(res.result).data);
        this.$set(row, "children", tempArr);
        this.$set(row, "loaded", true);
        this.brandTypeDataActive = tempArr
        return false
      }
      this.brandTypeDataActive = row.children;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.brandDataActive.checked = checkedCount === this.brandDataActive.children.length;
      this.brandDataActive.isIndeterminate = checkedCount > 0 && checkedCount < this.brandDataActive.children.length;
    },
    handleCheckAllChange (value) {
      this.brandDataActive.isIndeterminate = false
      if (this.brandDataActive.loaded) {
        this.brandDataActive.checkedChildren = value ? this.brandDataActive.children.map(i => (i.value)) : []
      } else {
        const unwatch = this.$watch('brandDataActive', val => {
          val.checkedChildren = val.checked ? val.children.map(i => (i.value)) : []
          unwatch()
        })
      }
      this.$emit('get-product-data', { checked: value, leaf: false, row: this.brandDataActive })
    },
    brandTypeChange (value, row) {
      this.$emit('get-product-data', { checked: value, leaf: true, row: row })
    },
    defaultCheckedOrDisabled (val) {
      if (this.options[0]?.children) {
        this[ val ? 'setDefaultChecked' : 'setDefaultDisabled' ](this.options)
      } else {
        const unwatch = this.$watch('options', options => {
          this[ val ? 'setDefaultChecked' : 'setDefaultDisabled' ](options)
          unwatch()
        })
      }
    },
    setDefaultChecked (options) {
      this.defaultCheckedKeys.forEach(i => {
        options.forEach(j => {
          if (i.financialBrandID == j.value) {
            j["checkedChildren"].push(i.itemTypeID)
            j["checkedChildren"] = Array.from(new Set(j["checkedChildren"]))
            let checkedChildrenLength = j["checkedChildren"].length
            let childrenLength = j["children"].length
            if (checkedChildrenLength < childrenLength) {
              j["checked"] = false
              j["isIndeterminate"] = true
            } else {
              j["checked"] = true
              j["isIndeterminate"] = false
            }
          }
        })
      })
    },
    setDefaultDisabled (options) {
      this.defaultDisabledKeys.forEach(i => {
        options.forEach(j => {
          if (i.financialBrandID == j.value) {
            j["disabled"] = true
            j["disabledChildren"].push(i.itemTypeID)
            j["disabledChildren"] = Array.from(new Set(j["disabledChildren"]))
          }
        })
      })
    }
  },
};
</script>

<style lang="less">
.cascader {
  height: 100%;
  display: flex;
  .el-scrollbar {
    flex: 1;
    &:not(:first-child) {
      border-left: solid 1px #e4e7ed;
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      .el-scrollbar__view {
        height: 100%;
        ul {
          padding: 6px 0;
          li {
            padding: 0 20px 0 6px;
            cursor: pointer;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover {
              background-color: #f5f7fa;
            }
          }
          .active {
            color: #409eff;
            font-weight: 700;
          }
        }
        .is-empty {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #c0c4cc;
        }
      }
    }
    .cascader-menu {
      & > div {
        display: flex;
        width: 100%;
        .text {
          display: inline-block;
          width: calc(100% - 40px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
